// extracted by mini-css-extract-plugin
export default {"container":"index_container__tHJKn","popoverContent":"index_popoverContent__SdPLv","imageWrapper":"index_imageWrapper__iSCNU","content":"index_content__QGQtz"};